import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Service/Offend/mobile-application/MobileApplicationPenetrationTest.tsx");
